import { BookingWidget } from "@/modules/coaching/booking/components/BookingWidget";
import { BookingContextProvider } from "@/modules/coaching/booking/context/BookingContext";
import { SessionToReschedulePill } from "@/modules/coaching/reschedule-sessions/components/SessionToReschedulePill";

type SessionBookingWidgetProps = {
  coachId?: number;
  customerId?: number;
  coachName?: string;
  rescheduleSessionId?: number;
  originalSessionStart?: string;
  memberName?: string;
  memberEmail?: string;
};

export const SessionBookingWidget = ({
  coachId,
  customerId,
  coachName,
  rescheduleSessionId,
  originalSessionStart,
  memberName,
  memberEmail,
}: SessionBookingWidgetProps) => {
  return (
    <BookingContextProvider
      initialData={{
        coachId,
        customerId,
        coachName,
        rescheduleSessionId,
        originalSessionStart,
        memberName,
        memberEmail,
      }}
    >
      {rescheduleSessionId != null && <SessionToReschedulePill />}
      <BookingWidget compact />
    </BookingContextProvider>
  );
};
